// extracted by mini-css-extract-plugin
export default {"close":"styles_close__hh95a"};